function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import Paper from '@material-ui/core/Paper';
import React from 'react';
import { components } from 'react-select';
import { SelectAllButton } from "../../CommonComponents";
export var MenuWeb = function MenuWeb(props) {
  var selectProps = props.selectProps,
      innerProps = props.innerProps,
      _props$children = props.children,
      children = _props$children === void 0 ? [] : _props$children;
  return /*#__PURE__*/React.createElement(components.Menu, props, /*#__PURE__*/React.createElement(Paper, _extends({
    square: true
  }, innerProps), selectProps.isMulti && selectProps.allowSelectAll && /*#__PURE__*/React.createElement(SelectAllButton, selectProps), children || []));
};